module.exports = __webpack_public_path__ + "img/ic_chevron_down.a0f1d8b0.svg";